import styled from "styled-components";

import { size } from "~/styles/screen";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 400px;
  min-width: 400px;
  margin-right: 40px;
  @media screen and (max-width: ${size.small}) {
    height: 100%;
    padding: 30px;
    margin-right: 0;
  }
`;

export const Title = styled.text`
  font-family: "Roboto Slab";
  font-weight: 900;
  font-size: 22px;
  line-height: 29.01px;
  margin-bottom: 45px;
  align-self: flex-start;

  @media screen and (max-width: ${size.small}) {
    height: 100%;
  }
`;

export const Text = styled.text`
  font-family: "Montserrat";
  font-weight: 800;
  font-size: 16px;
  line-height: 19.5px;
  margin-top: 20px;
  align-self: flex-start;
`;
